import React from "react";
import { useTranslation } from "react-i18next";
import { DataListType } from "Types/common.types";
import { DetailsContainer } from "Components/shared/details-container";
import "./driver-details.scss";

const DriverDetails = ({ driverDetails }) => {
  const { t } = useTranslation();
  const driverInfo: DataListType[] = [
    {
      label: t("label.fullName"),
      value: driverDetails?.fullName,
    },
    {
      label: t("label.nationalID").toUpperCase(),
      value: driverDetails?.passportID,
    },
    {
      label: t("label.emailAddress").toUpperCase(),
      value: driverDetails?.emailAddress,
    },
    {
      label: t("label.mobileNo"),
      value: driverDetails?.mobileNumber,
    },
    {
      label: t("label.gender"),
      value: driverDetails?.gender,
    },
    {
      label: t("label.homeAddress"),
      value: driverDetails?.fullAddress,
    },
  ];

  return <DetailsContainer listOfData={driverInfo} />;
};

export default DriverDetails;
